export const makeValidUrl = (input: string): string =>
  input.startsWith('http://') || input.startsWith('https://') ? input : 'https://' + input;
